// Populates the npm-replacement globals (`imagesLoaded`, `Isotope`)
// and wires jquery-bridget for isotope DURING the ESM import phase.
// Without this, the assignments happen in the customer_side entry's
// module body — too late for legacy library imports (e.g.
// template-functions.js reads `window.imagesLoaded` at import time)
// and for any jQuery plugin that uses `$.fn.isotope` immediately.
//
// Depends on `window.jQuery` already being set by `_jquery_setup.js`.
// Make sure that import precedes this one in the entry file.

import imagesLoaded from 'imagesloaded'
import Isotope from 'isotope-layout'
import jQueryBridget from 'jquery-bridget'

window.imagesLoaded = imagesLoaded
window.Isotope = Isotope
jQueryBridget('isotope', Isotope, window.jQuery)
